import React, {useState, useEffect, useCallback} from 'react';
import Link from 'gatsby-link';

import Wave from '../images/svg/wave.svg';
import WaveSmall from '../images/svg/wave-small.svg';
import Underline from '../images/svg/underline.svg';
import Smile from '../images/svg/ugyesvagyok-smile-white.svg';
import Logo from '../images/svg/ugyesvagyok-logo-color.svg';
import Facebook from '../images/svg/social-fb.svg';

import './header.scss';
import PropTypes from 'prop-types';


const Header = ({heroTitle, headerStyle}) => {

  const [state, setState] = useState({
    isHeaderBgVisible: false,
  });

  const [checked, setChecked] = useState(false);


  const handleScrollEvent = useCallback(() => {

    setState(() => ({
      isHeaderBgVisible: -document.body.getBoundingClientRect().y > 10
    }));
  }, []);

  useEffect(() => {
    const scrollListener = () => {
      handleScrollEvent();
    };
    window.addEventListener('scroll', scrollListener);

    return () => {
      window.removeEventListener('scroll', scrollListener);
    };
  }, [handleScrollEvent]);

  const menuItems = [
    {slug: '/kapcsolat', title: 'Kapcsolat'},
    {slug: '/orarend', title: 'Órarend'},
    {slug: '/taborok', title: 'Táborok'},
    // {slug: '/erre', title: 'Workshop'},
  ];

  const headerType = headerStyle || 'full';
  return <>
    <header className="header" style={{backgroundColor: state.isHeaderBgVisible || checked ? '#FF950AEE' : 'transparent'}}>
      <div className="container">
        <nav>
          <ul role="navigation">
            <li>
              <Link to={'/'} className="main-nav">
                <Smile className="logo-smile"/>
              </Link>
            </li>
            <label htmlFor="menu" className={'menu-button hidden-desktop'}>
              Menu
            </label>
            <input type="checkbox" id="menu" name="menu" className="hidden-mobile hidden-desktop" onChange={setChecked}/>
            {menuItems.map((item, index) =>
              <li key={index} className="hidden-mobile menu-item">
                <Link to={item.slug} className="main-nav">
                  {item.title}
                  <Underline className="menu-underline"/>
                </Link>
              </li>
            )}
            <li className="last">
              <a href="https://www.facebook.com/ugyesvagyok.hu" rel="noreferrer" target={'_blank'} className="main-nav">
                <Facebook className="fb-logo"/>
              </a>
            </li>
          </ul>
        </nav>
      </div>

    </header>
    {{
      'full': <>
        <Wave/>
        <div className="container">
          <Logo className="logo-main"/>
        </div>
        <h1 className="hero-title">{heroTitle}</h1>
      </>,
      'waves-brand': <>
        <Wave/>
        {/*<Logo className="logo-main"/>*/}
      </>,
      'waves': <>
        <WaveSmall/>
      </>,
      'none': <></>
    }[headerType]
    }
  </>;
};

Header.propTypes = {
  headerStyle: PropTypes.oneOf(['full', 'none', 'waves-brand', 'waves'])
};

export default Header;
